<template>
  <div>
    <div v-for="field in customfields"
         :key="field.id"
         class="bg-gray-100 rounded mb-1 py-2 px-3 flex justify-between">
      <div>{{ field.name }}</div>
      <div class="flex items-center">
        <BaseDropdown class="p-1 rounded hover:bg-gray-200 focus:bg-gray-200">
          <template v-slot:button>
            <BaseIcon name="more-vertical" />
          </template>
          <ModalButton class="dropdown-item w-32"
                       label="Wijzigen"
                       size="max-w-xl">
            <CustomfieldForm method="patch"
                             :action="`/json/customfields/${field.id}`"
                             :customfield="field" />
          </ModalButton>
          <DeleteConfirmButton class="dropdown-item w-32 text-red-500"
                               :message="`Weet je zeker dat je ${field.name} wilt verwijderen?`"
                               @confirm="deleteCustomfield(field)">
            Verwijderen
          </DeleteConfirmButton>
        </BaseDropdown>
      </div>
    </div>
    <div v-if="customfields.length === 0"
         class="text-gray-500">Nog geen eigen velden</div>
  </div>
</template>

<script>
import { destroy } from "@/api.js";
import CustomfieldForm from "@/components/CustomfieldForm";
import DeleteConfirmButton from "@/components/DeleteConfirmButton";

export default {
  props: {
    customfields: {
      type: Array,
      required: true
    }
  },

  components: {
    CustomfieldForm,
    DeleteConfirmButton
  },

  methods: {
    deleteCustomfield(field) {
      destroy(`/customfields/${field.id}`).then(response => {
        this.$store.commit("SET_SETTINGS", response.data);
        this.$store.commit("FLASH_ADD", {
          message: "Customveld is verwijderd!"
        });
      });
    }
  }
};
</script>
